
const set_newsletter_form = setInterval(()=>{
  const app_block = document.querySelector('#app-embed');
  const newsletter_container = document.querySelector('.footer__block--newsletter');
  let form_heading_size = '12px';
  let form_body_size = '11px';
  if(window.innerWidth > 999) {
    form_heading_size = '16px';
    form_body_size = '14px';
  }
  if(app_block != null && newsletter_container != null ) {
    app_block.shadowRoot.querySelector('#form-container-ref > section > section').style.margin = '0px';
    if(window.innerWidth < 1000) {
      app_block.shadowRoot.querySelector('#form-container-ref > section > section').style.maxWidth = '100%';
    }
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] > section').style.marginTop = '0px';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] section h2').style.textAlign = 'left';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] section h2').style.fontSize = form_heading_size;
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] section h2').style.color = '#000';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] section h2').style.fontWeight = '700';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] section h2').style.fontFamily = 'var(--text-font-family)!important';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] form #email').style.borderRadius = '0px';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] form #email').style.border = '1px solid #575757';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] form #email').style.boxShadow = 'none';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] fieldset legend').style.fontWeight = '700';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] fieldset legend').style.fontSize = form_body_size;
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] fieldset legend').style.fontFamily = 'var(--text-font-family)!important';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] fieldset legend + div').style.display = 'flex';
    app_block.shadowRoot.querySelectorAll('[data-sizing="form-wrapper"] fieldset legend + div > label input').forEach((elm)=>{
     elm.style.width = '26px';
     elm.style.height = '26px';
     elm.style.accentColor = '#000';
     elm.style.borderRadius = '0px';
     elm.style.border = '1px solid #000';
     elm.nextElementSibling.style.marginLeft = '10px';
     elm.nextElementSibling.style.fontWeight = '700';
     elm.nextElementSibling.style.fontSize = form_body_size;
     elm.nextElementSibling.style.fontFamily = 'var(--text-font-family)!important';
    });
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] fieldset + button').style.borderRadius = '0px';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] fieldset + button').style.fontWeight = '700';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] fieldset + button').style.fontFamily = 'var(--text-font-family)!important';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] form + div').style.lineHeight = '1.5';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] form + div').style.fontSize = form_body_size;
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] form + div').style.fontFamily = 'var(--text-font-family)!important';
    app_block.shadowRoot.querySelector('[data-sizing="form-wrapper"] form + div p').style.textAlign = 'left';
    newsletter_container.appendChild(app_block);
    clearInterval(set_newsletter_form);
  }
}, 500);



function initializeFooterAccordion() {
  if(window.innerWidth < 1000) {
    const links = document.querySelectorAll('.footer__block--links > .v-stack');
    if(links != null) {
      links.forEach((elm)=>{
        if(typeof elm == 'object') {
          const container = document.createElement('div');
          const button = elm.querySelector('.h6');
          button.classList.add('c-accordion-button');
          container.classList.add('c-accordion-container');
          elm.appendChild(container);
          elm.querySelector('ul').classList.add('c-accordion-inner');
          container.appendChild(elm.querySelector('ul'));
          button.setAttribute('aria-controls', '');
          button.setAttribute('aria-expanded', false);
          let state = false;
          button.addEventListener('click', (e)=>{
            state = !state;
            button.setAttribute('aria-expanded', state);
          });
        }
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', ()=>{
  initializeFooterAccordion();
});



document.addEventListener('DOMContentLoaded', ()=>{
  const columns = document.querySelectorAll('.multi-column__item');
  if(columns != null) {
    columns.forEach((elm)=>{
      elm.addEventListener('click', (e)=>{
        const a = elm.querySelector('a');
        if(e.target != a) {
          a.click();
        }
      });
    });
  }
});



  document.addEventListener('DOMContentLoaded', ()=>{
    const show_preferences = document.querySelectorAll('a[href*="#show_preferences"]');
    if(show_preferences != null) {
      show_preferences.forEach((elm)=>{
        elm.addEventListener('click', (e)=>{
          e.preventDefault();
          e.stopPropagation();
          privacyBanner.showPreferences();
        });
      });
    }
  });
